import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-card';

const depositActivities = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/card-activities`, data);
};

const depositBalance = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/cards`, data);
};

const rechargeStrategies = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/recharge-strategies`, data);
};

const updateRechargeStrategies = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/recharge-strategies`, data);
};

const deleteRechargeStrategies = (merchantId, strategyId) => {
	return Client.del(
		`${baseUrl}/${merchantId}/recharge-strategies/${strategyId}`
	);
};

export default {
	depositActivities,
	depositBalance,
	rechargeStrategies,
	updateRechargeStrategies,
	deleteRechargeStrategies,
};
